import { render, staticRenderFns } from "./modalCancelarPedido.vue?vue&type=template&id=88643210&scoped=true&"
import script from "./modalCancelarPedido.vue?vue&type=script&lang=js&"
export * from "./modalCancelarPedido.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88643210",
  null
  
)

export default component.exports